import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchCandidatesSuccess,
  fetchCandidatesFailure,
  fetchKeepInViewCandidatesSuccess,
  fetchKeepInViewCandidatesFailure,
  fetchAdmittedCandidatesSuccess,
  fetchAdmittedCandidatesFailure,
  fetchDeclinedCandidatesSuccess,
  fetchDeclinedCandidatesFailure,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';

const { API_BASE_URL } = urls || {};

function* getCandidates({
  stage,
  applicationId,
  adminlevel,
  course,
  page = 0,
  pageSize = 10,
  searchTerm,
  gender,
  nationality,
  stateOfOrigin,
  lgaOfOrigin,
  modeOfEntry,
  refereeStatus,
}) {
  const url = `${API_BASE_URL}/candidates?stage=${stage}&applicationId=${applicationId}&page=${page}&size=${pageSize}${
    adminlevel ? `&administrationLevelItemIds=${adminlevel}` : ''
  }${course ? `&courseIds=${course}` : ''}${
    searchTerm ? `&keyword=${searchTerm}` : ''
  }${gender ? `&gender=${gender}` : ''}${
    nationality ? `&nationality=${nationality}` : ''
  }${stateOfOrigin ? `&stateOfOrigin=${stateOfOrigin}` : ''}${
    lgaOfOrigin ? `&lgaOfOrigin=${lgaOfOrigin}` : ''
  }${modeOfEntry ? `&modeOfEntry=${modeOfEntry}` : ''}${
    refereeStatus ? `&refereeStatus=${refereeStatus}` : ''
  }`;

  const response = yield request({
    method: 'get',
    url,
  });
  return response;
}

function* fetchNewCandidates({ payload }) {
    const {
      applicationId,
      adminlevel,
      course,
      page,
      pageSize,
      searchTerm,
      gender,
      nationality,
      stateOfOrigin,
      lgaOfOrigin,
      modeOfEntry,
      refereeStatus,
    } = payload;
  
    const response = yield getCandidates({
      stage: 'SUBMITTED',
      applicationId,
      adminlevel,
      course,
      page,
      pageSize,
      searchTerm,
      gender,
      nationality,
      stateOfOrigin,
      lgaOfOrigin,
      modeOfEntry,
      refereeStatus,
    });
  
    if (response.success) {
      yield put(fetchCandidatesSuccess(response.raw));
    } else {
      yield put(fetchCandidatesFailure(response.message));
    }
}

function* fetchKeepInViewCandidates({ payload }) {
  const {
    applicationId,
    adminlevel,
    course,
    page,
    pageSize,
    searchTerm,
    gender,
    nationality,
    stateOfOrigin,
    lgaOfOrigin,
    modeOfEntry,
    refereeStatus,
  } = payload;

  const response = yield getCandidates({
    stage: 'KEEP_IN_VIEW',
    applicationId,
    adminlevel,
    course,
    page,
    pageSize,
    searchTerm,
    gender,
    nationality,
    stateOfOrigin,
    lgaOfOrigin,
    modeOfEntry,
    refereeStatus,
  });

  if (response.success) {
    yield put(fetchKeepInViewCandidatesSuccess(response.raw));
  } else {
    yield put(fetchKeepInViewCandidatesFailure(response.message));
  }
}

function* fetchAdmittedCandidates({ payload }) {
  const {
    applicationId,
    adminlevel,
    course,
    page,
    pageSize,
    searchTerm,
    gender,
    nationality,
    stateOfOrigin,
    lgaOfOrigin,
    modeOfEntry,
    refereeStatus,
  } = payload;

  const response = yield getCandidates({
    stage: 'ACCEPTED',
    applicationId,
    adminlevel,
    course,
    page,
    pageSize,
    searchTerm,
    gender,
    nationality,
    stateOfOrigin,
    lgaOfOrigin,
    modeOfEntry,
    refereeStatus,
  });

  if (response.success) {
    yield put(fetchAdmittedCandidatesSuccess(response.raw));
  } else {
    yield put(fetchAdmittedCandidatesFailure(response.message));
  }
}

function* fetchDeclinedCandidates({ payload }) {
  const {
    applicationId,
    adminlevel,
    course,
    page,
    pageSize,
    searchTerm,
    gender,
    nationality,
    stateOfOrigin,
    lgaOfOrigin,
    modeOfEntry,
    refereeStatus,
  } = payload;

  const response = yield getCandidates({
    stage: 'DECLINED',
    applicationId,
    adminlevel,
    course,
    page,
    pageSize,
    searchTerm,
    gender,
    nationality,
    stateOfOrigin,
    lgaOfOrigin,
    modeOfEntry,
    refereeStatus,
  });

  if (response.success) {
    yield put(fetchDeclinedCandidatesSuccess(response.raw));
  } else {
    yield put(fetchDeclinedCandidatesFailure(response.raw));
  }
}

export function* getNewCandidates() {
  yield takeEvery(
    ApplicantsActionTypes.START_FETCH_APPLICANTS,
    fetchNewCandidates
  );
}

export function* getKeepInViewCandidates() {
  yield takeEvery(
    ApplicantsActionTypes.START_FETCH_KEEP_IN_VIEW_APPLICANTS,
    fetchKeepInViewCandidates
  );
}

export function* getAdmittedCandidates() {
  yield takeEvery(
    ApplicantsActionTypes.START_FETCH_ADMITTED_APPLICANTS,
    fetchAdmittedCandidates
  );
}

export function* getDeclinedCandidates() {
  yield takeEvery(
    ApplicantsActionTypes.START_FETCH_DECLINED_APPLICANTS,
    fetchDeclinedCandidates
  );
}
